import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Shared axios instance. All requests carry cookies (httpOnly access_token +
// refresh_token) and, when available, also attach a Bearer token so
// same-origin curls or offline test scripts hit the same code path.
export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

const BEARER_KEY = "ftg_access_token";

export function setBearer(token) {
  if (token) {
    localStorage.setItem(BEARER_KEY, token);
  } else {
    localStorage.removeItem(BEARER_KEY);
  }
}

export function getBearer() {
  return localStorage.getItem(BEARER_KEY);
}

api.interceptors.request.use((config) => {
  const t = getBearer();
  if (t) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  }
  return config;
});

// Absolute URL builder for <audio src="..."> (needs cookie or ?bearer=...
// on cross-origin — but frontend + backend share the preview host so cookies
// flow naturally; we ALSO append the Bearer query param as a belt-and-braces
// fallback in case of stricter cookie policies on mobile Safari).
export function audioUrl(lessonId) {
  const t = getBearer();
  const q = t ? `?token=${encodeURIComponent(t)}` : "";
  return `${BASE}/api/lessons/${encodeURIComponent(lessonId)}/audio${q}`;
}

// Reader PDF download URL. Same cookie / ?token= dual approach as audioUrl —
// the endpoint enforces JWT auth + tier access.
export function readerDownloadUrl(ageBand, termInt, chapter) {
  const t = getBearer();
  const q = t ? `?token=${encodeURIComponent(t)}` : "";
  return `${BASE}/api/readers/${encodeURIComponent(ageBand)}/term_${termInt}/chapter/${chapter}/download${q}`;
}

export const API_BASE = BASE;
